export default "__VITE_ASSET__7e297ab1__"